import {Injectable, Inject} from 'ng-metadata/core';
import {
    AuthenticationMethod,
    getInstitutionCode,
    getAuthenticationMethods,
    getVid,
    getBackendSystem,
    isUnionCatalogNZView
} from '../../appConfig/appConfigForward';
import {bootstrapJwt, UserSessionManagerService} from '../userSessionManager.service';
import {PrimoExploreService} from '../../primoExplore/primoExplore.service';
import {PrimolyticsService, beacon} from '../../analytics/primolytics.service';
import {JwtUtilService} from '../jwtUtil.service';
import {STATE_NAMES} from '../../primoExplore/primoExploreStates.module';
import {StorageUtil} from "../../infra/storageUtil.service";
import {UnionCatalogLoginService} from "./unionCatalogLogin/unionCatalogLogin.service";
import {DirectLoginService} from "./unionCatalogLogin/directLogin.service";
import {AnalyticsUtils} from "../../nddUtils/analyticsUtils.service";
var angular:angular.IAngularStatic =  require('angular');

const _get = require('lodash/get');

@Injectable()
export class LoginService {
    private _toState;
    private _toParams;
    private _toUrl;

    constructor(@Inject('$window') private $window: ng.IWindowService,
                @Inject('$location') private $location: ng.ILocationService,
                @Inject('$mdDialog') private $mdDialog: ng.material.IDialogService,
                private userSessionManagerService: UserSessionManagerService,
                @Inject('$state') private $state: ng.ui.IStateService,
                private primoExploreService: PrimoExploreService,
                private primolyticsService: PrimolyticsService,
                private jwtUtilService: JwtUtilService,
                private storageUtil: StorageUtil,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                private unionCatalogLoginService : UnionCatalogLoginService,
                private directLoginService: DirectLoginService,
                private analyticsUtils: AnalyticsUtils,
                @Inject('$rootScope') private $rootScope: ng.IRootScopeService) {
        this.$rootScope.$on('showLoginPopup', (event, resolve, reject) => {
            this.handleInternalLogin('nde.login.continue_search', 'nde.login.continue_search_subtitle', true)
                .then(resolve, reject);
        });
    }

    public async redirectLogin( authenticationMethod: AuthenticationMethod, targetURL = '', isSilent = false) {
    	await bootstrapJwt();
        if (!targetURL){
            if ( this._toUrl) {
                // When there is a saved URL, e.g. dual login with external syst em
                targetURL = this._toUrl;
                this._toUrl = '';
            }
            else if(this.toState && this.toParams){
                targetURL = this.normalizeTargetUrl(this.$state.href(this.toState, this.toParams,{absolute : true}), this.toParams);
            }
        }
        this.$window.location.assign(
			this.loginUrl( authenticationMethod.profileName, authenticationMethod.authenticationSystem, targetURL, isSilent )
		);
    }

    //For Suprima requirements, do not remove auth system
    public loginUrl( authenticationProfileName, authenticationProfileSystem, targetURL, isSilent=false) {
        let returnURL = '';
        if ( targetURL ) {
            // When redirecting from deep link login
            returnURL = targetURL;
        }
        else {
            if ( this._toState && this._toState !== null && (this._toState.name === 'account' ||
                this._toState.name === STATE_NAMES.BLANK_ILL || this._toState.name === STATE_NAMES.PURCHASE_REQUEST )) {
                this.$location.path( this._toState.name );
            }
            //we get to this condition only from section=queries
            else if ( this._toState && this._toState !== null && this._toState.name === STATE_NAMES.FAVORITES) {
                this.$location.path('favorites').search('section', 'queries');
            }

            returnURL = this.normalizeTargetUrl();
        }

        if ( this._toState && this._toState !== null &&
            (this._toState.name === 'account' || this._toState.name === STATE_NAMES.FAVORITES ||
            this._toState.name === STATE_NAMES.BLANK_ILL || this._toState.name === STATE_NAMES.PURCHASE_REQUEST ) ) {
            returnURL += '&fromLogin=true';
            returnURL = returnURL.replace('&authenticationError=1','');
        }

        if(isSilent){
            returnURL+='&isIframeSSO=true';
        }

        let isValidJWT = this.userSessionManagerService.isJWTValidForApp(this.jwtUtilService.getJwtFromLocalStorage());
        let institutionCode = this.jwtUtilService.getDecodedToken().institution;
        if (!institutionCode || !isValidJWT) {
            institutionCode =  getInstitutionCode();
        }

       if(getBackendSystem() === 'suprima'){
            let view = this.jwtUtilService.getDecodedToken().viewId;
            let lang =  this.$translate.use() || this.$location.search().lang;
        	if (!view || !isValidJWT) {
            	view = getVid();
        }
            
	        return '/primaws/suprimaExtLogin?institution=' + encodeURIComponent( institutionCode ) +
            	'&lang=' + encodeURIComponent( lang ) +
            	'&target-url=' + encodeURIComponent( returnURL ) +
            	'&authenticationProfile=' + encodeURIComponent( authenticationProfileName ) +
            	'&idpCode=' + encodeURIComponent( authenticationProfileName ) +
            	'&auth=' + encodeURIComponent( authenticationProfileSystem )+
            	'&view='+encodeURIComponent( view )+
            	'&isSilent='+isSilent;
        }else{
        	return '/primo_library/libweb/primoExploreLogin?institution=' + encodeURIComponent( institutionCode ) +
            	'&lang=' + encodeURIComponent( this.$location.search().lang ) +
            	'&target-url=' + encodeURIComponent( returnURL ) +
           		'&authenticationProfile=' + encodeURIComponent( authenticationProfileName ) +
            	'&auth=' + encodeURIComponent( authenticationProfileSystem )+
            	'&isSilent='+isSilent;
        }
   
    }

    public normalizeTargetUrl(returnURL ?, stateParams ?) {

    	// We realized that if we want any of the search parameters (query, facet, service page params) to come back to the client properly,
    	// it should be sent FROM PDS/IDP encoded TWICE (since the target URL will be decoded twice along the way because of automatic servlet decoding).
    	// If we need the external system to sent it with double encoding, the client should encode these values 3 TIMES.
    	// The login servlet will get the target URL encoded twice (automatic servlet decoding) and it will be encoded one more time before sending it to the external system.
    	// In addition, there are some characters that are not handled by the javascript encodeURIComponent method so we are handling it separately in the replaceCharacters method.
    	// So this method (normalizeTargetUrl) will encode all parameters (exception - vid) values 2 times, and the loginUrl method will encode the entire target URL one more time

    	if (!returnURL){
    	    returnURL = this.$location.absUrl()
        }
        returnURL = decodeURIComponent(returnURL);

        stateParams = stateParams || this.$state.params;

    	angular.forEach(stateParams, function(value, key) {
    		if (key !== 'vid' && key !== 'lang' && value) {
	    		if (Array.isArray(value)) {
	            	value.map((pValue) => {
	        			returnURL = returnURL.replace(pValue, encodeURIComponent(this.replaceCharacters(encodeURIComponent(pValue))));
	            	});
	            } else {
	            	let pValue = value;
	            	returnURL = returnURL.replace(key+'='+pValue, key+"="+encodeURIComponent(this.replaceCharacters(encodeURIComponent(pValue))));
	        	}
        	}
    	}, this);

    	return returnURL;
    }

    private replaceCharacters(qString) {
    	return qString.replace(/\'/g, '%27')
    				  .replace(/~/g, '%7E')
    				  .replace(/!/g, '%21')
    				  .replace(/\*/g, '%2A')
    				  .replace(/\(/g, '%28')
    				  .replace(/\)/g, '%29')
    				  .replace(/-/g, '%2D')
    				  .replace(/_/g, '%5F')
    				  .replace(/\+/g, '%2B')
    				  .replace(/\_/g, '%2E');
    }

    public redirectToTargetURL(targetURL = '') {
        if(!targetURL){
            targetURL = this.$location.search().targetURL;
        }
        if ( targetURL ) {
            this.$window.location.assign( targetURL );
        }
        else if ( this._toState ) {
            this.loadSavedState();
        }else{
			//No state default to login
			this._toState = 'login';
			this.loadSavedState();
		}        
    }

    public loadSavedState(toState?, toParams?) {
        toState = toState || this._toState;
        let resetOffset = false;
        if (toState === 'openurl'){
            toState = 'servicesPage';
        }
        else if (toState === 'search') {
            toState = STATE_NAMES.SEARCH;
            resetOffset = true;
        }
        else if (toState === 'favorites') {
            toState = STATE_NAMES.FAVORITES;
        }
        else if (toState === 'jsearch') {
            toState = STATE_NAMES.JOURNAL_SEARCH;
            resetOffset = true;
        }
        else if (toState === 'dbsearch') {
            toState = STATE_NAMES.DB_SEARCH;
            resetOffset = true;
        }
        else if (toState === 'orgList') {
            toState = STATE_NAMES.ORGANIZATION_LIST;
        }
        else if (toState === 'npsearch') {
            toState = STATE_NAMES.NEWSPAPERS;
            resetOffset = true;
        }
        else if (toState === 'authsearch') {
            toState = STATE_NAMES.AUTHORITY_SEARCH;
            resetOffset = true;
        }
        toParams = toParams || this._toParams;
        if (resetOffset && toParams && toParams.offset) {
            toParams.offset = 0;
        }
        this._toState = '';
        this._toParams = '';
        this.$state.go(toState, toParams, { reload: true });
    }

    public clearSavedState() {
    	this._toState = '';
        this._toParams = '';
        this._toUrl = '';
    }

    public handleLoginClick() {
        if ( getAuthenticationMethods().length > 1 ) {
            // Dual login
            this.handleInternalLogin();
        }
        else {
            // Single login
            let authenticationMethod = getAuthenticationMethods()[0];
            if ( authenticationMethod.isExternal() ) {
                this.redirectLogin( authenticationMethod );
            }else if (this.$state.current.name === 'delivery' || this.$state.current.name === 'canonDelivery' || this.$state.current.name === 'cnameDelivery' ) {
                let view = getVid();
                if (view != undefined && view.split(':').length > 1 && view.split(':')[1] != undefined && view.split(':')[1]  != 'AlmaGeneralView'){
                     this.handleInternalLogin();
                }else {
                    let institutionCode = this.jwtUtilService.getDecodedToken().institution;	
                    if (!institutionCode) {
                        institutionCode = getInstitutionCode();
                    }
                    let return_delivery_url=encodeURIComponent(this.$window.location.pathname+this.$window.location.search);
                    this.$window.location.href='/services/login?institute='+institutionCode+'&backUrlDel='+return_delivery_url;
                   //this.$window.location.href=this.userSessionManagerService.attributesMap.sessionTimeoutURL+'&backUrlDel='+return_delivery_url;
                }
            }
            else {
            	this.handleInternalLogin();
            }
        }
    }

    @beacon({'p':'general', 'op':'signIn'})
    public callHandleLoginClickWithBeacon() {
        this.handleLoginClick();
        this.sendAnalytics();
    }

    public sendAnalytics(signInMethod) {
        //signInMethod can be 'manually' or 'SSO'
        if (!signInMethod) {
            signInMethod = 'manually';
        }
        let payload = {
            'Sign In Method' :  signInMethod
        }
        this.analyticsUtils.trackUsage(this.analyticsUtils.eventsNames.SIGN_IN, payload);
    }

    public handleInternalLogin(headerText?: string, headerSubText?: string, disableAutoRedirect?: boolean): Promise<void> {
        this.handleLogin();
        if (this.isUnionCatalogNZView() || this.isDirectLoginEnabledForView()){
            return this.showUnionCatalogLoginDialog(headerText, headerSubText);
        }
        else {
            return this.showLoginDialog(headerText, headerSubText, disableAutoRedirect);
        }
    }

    public handleLogin() {
        if (this._toState) {
            // This means we already saved a state to return to (e.g. when going to my library,
            // fired by changeStateEvent), so nothing to do here
        }
        else {
            // Save the current URL as a state to return to
            this._toParams = this.$location.search();
            //temporary fix for current ui-router version (<1.0)
            for (var param in this._toParams) {
                if (this._toParams[param] && typeof this.toParams[param] === 'string')
                    this._toParams[param] = this._toParams[param].replace('~2F', '/');
            }
            this._toState = this.$location.path().replace(/^\/|\/$/g, ''); // Remove leading and trailing '/'
            this._toUrl = this.normalizeTargetUrl();
        }

    }
	
	public getToUrl(){
		if(!this._toUrl){
			this._toUrl = this.normalizeTargetUrl();
		}
		return this._toUrl;
	}
	
    public showLoginDialog(headerText?: string, headerSubText?: string, disableAutoRedirect?: boolean): Promise<void> {
        let templateString = '' +
            '<md-dialog aria-label="'+this.loginAriaTranslated()+'" class="login-dialog light-on-dark-dialog tabbed-dialog"> ' +
                '<prm-login layout="row"' +
                ' [authentication-methods]="ctrl.authenticationMethods"' +
                ' [header-text]="ctrl.headerText"' +
                ' [header-sub-text]="ctrl.headerSubText"' +
                ' [disable-auto-redirect]="ctrl.disableAutoRedirect"' +
            '></prm-login> ' +
            '</md-dialog>';

        this.addBackgroundDarkClass();

        const ret: ng.IPromise<any> = this.$mdDialog.show({
            focusOnOpen: false,
            multiple: true,
            bindToController: true,
            controller : function(){},
            controllerAs:'ctrl',
            locals:{
                authenticationMethods: getAuthenticationMethods(),
                headerText: headerText,
                headerSubText: headerSubText,
                disableAutoRedirect: disableAutoRedirect
            },
            template: templateString
        });
        return Promise.resolve(ret);
    }

    public loginAriaTranslated() {
        return this.$translate.instant('nui.aria.login.loginDialog');
    }

    get toState() {
        return this._toState;
    }

    set toState( toState ) {
        this._toState = toState;
    }

    get toParams() {
        return this._toParams;
    }

    set toParams( toParams ) {
        this._toParams = toParams;
    }

    public addBackgroundDarkClass() {
        this.primoExploreService.dimScreen( true );
    }

    public removeBackgroundDarkClass() {
        this.primoExploreService.dimScreen( false );
    }

    private showUnionCatalogLoginDialog(headerText?: string, headerSubText?: string): Promise<void> {
        let templateString = '' +
            '<md-dialog aria-label="'+this.loginAriaTranslated()+'" class="login-dialog light-on-dark-dialog tabbed-dialog"> ' +
            '<prm-union-catalog-login layout="row"' +
                ' [state]="ctrl.state"' +
                ' [header-text]="ctrl.headerText"' +
                ' [header-sub-text]="ctrl.headerSubText"></prm-union-catalog-login> ' +
            '</md-dialog>';

        this.addBackgroundDarkClass();

        const ret: ng.IPromise<any> = this.$mdDialog.show({
            focusOnOpen: false,
            bindToController: true,
            controller : function(){}, 
            controllerAs:'ctrl',  
            locals:{
                state : {toState : this._toState , toParams : this._toParams},
                headerText: headerText,
                headerSubText: headerSubText
            },
            template: templateString,
            onComplete: (_scope, element: ng.IAugmentedJQuery) => {
                const input = element[0].querySelector('#uc-search-input') as HTMLElement | null;
                if (input) {
                    requestAnimationFrame(() => input.focus());
                }
            }
        });
        return Promise.resolve(ret);
    }

    public isUnionCatalogLogin() {
        return this.userSessionManagerService.isUnionCatalogLogin();
    }

    private isUnionCatalogNZView(){
        return isUnionCatalogNZView();
    }

    private isDirectLoginEnabledForView() {
        return this.directLoginService.isDirectLoginEnabled();
    }

    public returnToUnionCatalogNZView(){
        this.unionCatalogLoginService.returnToUnionCatalogNZView();
    }

    public getErrorMessageObj(responseErrorObj, defaultErrorMessage : string ) {
        let errorMessage = defaultErrorMessage;
        let errorFields = {};
        if(responseErrorObj){
            switch (_get(responseErrorObj,'errorMessage')) {
                case 'ncipMessageBlock':
                    errorMessage = 'login.error.ncip.message.block';
                    errorFields = {idx_1: responseErrorObj.errorValue};
                    break;
                case 'ncipMessageError':
                    errorMessage = 'login.error.ncip.message.error';
                    errorFields = {idx_1: responseErrorObj.errorType, idx_2: responseErrorObj.errorDetail , idx_3: responseErrorObj.errorValue };
                    break;
                case 'ncipMessageTimeout':
                    errorMessage = 'login.error.ncip.message.timeout';
                    break;
                case 'ncipImportUserError' :
                    errorMessage = 'rapido.sa.failed.to.update.user.account'
            }
        }
       return {errorMessage : errorMessage, errorFields : errorFields }
    }

}
//put here all angular1 modules the service is using
export default [];



// WEBPACK FOOTER //
// ./src/main/webapp/components/security/login/login.service.ts